! function(e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof module && module.exports ? module.exports = function(t, i) {
        return void 0 === i && (i = "undefined" != typeof window ? require("jquery") : require("jquery")(t)), e(i), i
    } : e(jQuery)
}(function(e) {
    "use strict";
    var t = e(document),
        i = e(window),
        s = ["a", "e", "i", "o", "u", "n", "c", "y"],
        o = [/[\xE0-\xE5]/g, /[\xE8-\xEB]/g, /[\xEC-\xEF]/g, /[\xF2-\xF6]/g, /[\xF9-\xFC]/g, /[\xF1]/g, /[\xE7]/g, /[\xFD-\xFF]/g],
        n = function(t, i) {
            this.element = t, this.$element = e(t), this.state = {
                multiple: !!this.$element.attr("multiple"),
                enabled: !1,
                opened: !1,
                currValue: -1,
                selectedIdx: -1,
                highlightedIdx: -1
            }, this.eventTriggers = {
                open: this.open,
                close: this.close,
                destroy: this.destroy,
                refresh: this.refresh,
                init: this.init
            }, this.init(i)
        };
    n.prototype = {
        utils: {
            isMobile: function() {
                return /android|ip(hone|od|ad)/i.test(navigator.userAgent)
            },
            escapeRegExp: function(e) {
                return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
            },
            replaceDiacritics: function(e) {
                for (var t = o.length; t--;) e = e.toLowerCase().replace(o[t], s[t]);
                return e
            },
            format: function(e) {
                var t = arguments;
                return ("" + e).replace(/\{(?:(\d+)|(\w+))\}/g, function(e, i, s) {
                    return s && t[1] ? t[1][s] : t[i]
                })
            },
            nextEnabledItem: function(e, t) {
                for (; e[t = (t + 1) % e.length].disabled;);
                return t
            },
            previousEnabledItem: function(e, t) {
                for (; e[t = (t > 0 ? t : e.length) - 1].disabled;);
                return t
            },
            toDash: function(e) {
                return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()
            },
            triggerCallback: function(t, i) {
                var s = i.element,
                    o = i.options["on" + t],
                    n = [s].concat([].slice.call(arguments).slice(1));
                e.isFunction(o) && o.apply(s, n), e(s).trigger("selectric-" + this.toDash(t), n)
            },
            arrayToClassname: function(t) {
                var i = e.grep(t, function(e) {
                    return !!e
                });
                return e.trim(i.join(" "))
            }
        },
        init: function(t) {
            var i = this;
            if (i.options = e.extend(!0, {}, e.fn.selectric.defaults, i.options, t), i.utils.triggerCallback("BeforeInit", i), i.destroy(!0), i.options.disableOnMobile && i.utils.isMobile()) i.disableOnMobile = !0;
            else {
                i.classes = i.getClassNames();
                var s = e("<input/>", {
                        class: i.classes.input,
                        readonly: i.utils.isMobile()
                    }),
                    o = e("<div/>", {
                        class: i.classes.items,
                        tabindex: -1
                    }),
                    n = e("<div/>", {
                        class: i.classes.scroll
                    }),
                    r = e("<div/>", {
                        class: i.classes.prefix,
                        html: i.options.arrowButtonMarkup
                    }),
                    a = e("<span/>", {
                        class: "label"
                    }),
                    c = i.$element.wrap("<div/>").parent().append(r.prepend(a), o, s),
                    l = e("<div/>", {
                        class: i.classes.hideselect
                    });
                i.elements = {
                    input: s,
                    items: o,
                    itemsScroll: n,
                    wrapper: r,
                    label: a,
                    outerWrapper: c
                }, i.options.nativeOnMobile && i.utils.isMobile() && (i.elements.input = void 0, l.addClass(i.classes.prefix + "-is-native"), i.$element.on("change", function() {
                    i.refresh()
                })), i.$element.on(i.eventTriggers).wrap(l), i.originalTabindex = i.$element.prop("tabindex"), i.$element.prop("tabindex", -1), i.populate(), i.activate(), i.utils.triggerCallback("Init", i)
            }
        },
        activate: function() {
            var e = this.elements.items.closest(":visible").children(":hidden").addClass(this.classes.tempshow),
                t = this.$element.width();
            e.removeClass(this.classes.tempshow), this.utils.triggerCallback("BeforeActivate", this), this.elements.outerWrapper.prop("class", this.utils.arrayToClassname([this.classes.wrapper, this.$element.prop("class").replace(/\S+/g, this.classes.prefix + "-$&"), this.options.responsive ? this.classes.responsive : ""])), this.options.inheritOriginalWidth && t > 0 && this.elements.outerWrapper.width(t), this.unbindEvents(), this.$element.prop("disabled") ? (this.elements.outerWrapper.addClass(this.classes.disabled), this.elements.input && this.elements.input.prop("disabled", !0)) : (this.state.enabled = !0, this.elements.outerWrapper.removeClass(this.classes.disabled), this.$li = this.elements.items.removeAttr("style").find("li"), this.bindEvents()), this.utils.triggerCallback("Activate", this)
        },
        getClassNames: function() {
            var t = this,
                i = t.options.customClass,
                s = {};
            return e.each("Input Items Open Disabled TempShow HideSelect Wrapper Focus Hover Responsive Above Scroll Group GroupLabel".split(" "), function(e, o) {
                var n = i.prefix + o;
                s[o.toLowerCase()] = i.camelCase ? n : t.utils.toDash(n)
            }), s.prefix = i.prefix, s
        },
        setLabel: function() {
            var t = this,
                i = t.options.labelBuilder;
            if (t.state.multiple) {
                var s = e.isArray(t.state.currValue) ? t.state.currValue : [t.state.currValue];
                s = 0 === s.length ? [0] : s;
                var o = e.map(s, function(i) {
                    return e.grep(t.lookupItems, function(e) {
                        return e.index === i
                    })[0]
                });
                o = e.grep(o, function(t) {
                    return o.length > 1 || 0 === o.length ? "" !== e.trim(t.value) : t
                }), o = e.map(o, function(s) {
                    return e.isFunction(i) ? i(s) : t.utils.format(i, s)
                }), t.options.multiple.maxLabelEntries && (o.length >= t.options.multiple.maxLabelEntries + 1 ? (o = o.slice(0, t.options.multiple.maxLabelEntries)).push(e.isFunction(i) ? i({
                    text: "..."
                }) : t.utils.format(i, {
                    text: "..."
                })) : o.slice(o.length - 1)), t.elements.label.html(o.join(t.options.multiple.separator))
            } else {
                var n = t.lookupItems[t.state.currValue];
                t.elements.label.html(e.isFunction(i) ? i(n) : t.utils.format(i, n))
            }
        },
        populate: function() {
            var t = this,
                i = t.$element.children(),
                s = t.$element.find("option"),
                o = s.filter(":selected"),
                n = s.index(o),
                r = 0,
                a = t.state.multiple ? [] : 0;
            o.length > 1 && t.state.multiple && (n = [], o.each(function() {
                n.push(e(this).index())
            })), t.state.currValue = ~n ? n : a, t.state.selectedIdx = t.state.currValue, t.state.highlightedIdx = t.state.currValue, t.items = [], t.lookupItems = [], i.length && (i.each(function(i) {
                var s = e(this);
                if (s.is("optgroup")) {
                    var o = {
                        element: s,
                        label: s.prop("label"),
                        groupDisabled: s.prop("disabled"),
                        items: []
                    };
                    s.children().each(function(i) {
                        var s = e(this);
                        o.items[i] = t.getItemData(r, s, o.groupDisabled || s.prop("disabled")), t.lookupItems[r] = o.items[i], r++
                    }), t.items[i] = o
                } else t.items[i] = t.getItemData(r, s, s.prop("disabled")), t.lookupItems[r] = t.items[i], r++
            }), t.setLabel(), t.elements.items.append(t.elements.itemsScroll.html(t.getItemsMarkup(t.items))))
        },
        getItemData: function(t, i, s) {
            return {
                index: t,
                element: i,
                value: i.val(),
                className: i.prop("class"),
                text: i.html(),
                slug: e.trim(this.utils.replaceDiacritics(i.html())),
                selected: i.prop("selected"),
                disabled: s
            }
        },
        getItemsMarkup: function(t) {
            var i = this,
                s = "<ul>";
            return e.isFunction(i.options.listBuilder) && i.options.listBuilder && (t = i.options.listBuilder(t)), e.each(t, function(t, o) {
                void 0 !== o.label ? (s += i.utils.format('<ul class="{1}"><li class="{2}">{3}</li>', i.utils.arrayToClassname([i.classes.group, o.groupDisabled ? "disabled" : "", o.element.prop("class")]), i.classes.grouplabel, o.element.prop("label")), e.each(o.items, function(e, t) {
                    s += i.getItemMarkup(t.index, t)
                }), s += "</ul>") : s += i.getItemMarkup(o.index, o)
            }), s + "</ul>"
        },
        getItemMarkup: function(t, i) {
            var s = this.options.optionsItemBuilder,
                o = {
                    value: i.value,
                    text: i.text,
                    slug: i.slug,
                    index: i.index
                };
            return this.utils.format('<li data-index="{1}" class="{2}">{3}</li>', t, this.utils.arrayToClassname([i.className, t === this.items.length - 1 ? "last" : "", i.disabled ? "disabled" : "", i.selected ? "selected" : ""]), e.isFunction(s) ? this.utils.format(s(i), i) : this.utils.format(s, o))
        },
        unbindEvents: function() {
            this.elements.wrapper.add(this.$element).add(this.elements.outerWrapper).add(this.elements.input).off(".sl")
        },
        bindEvents: function() {
            var t = this;
            t.elements.outerWrapper.on("mouseenter.sl mouseleave.sl", function(i) {
                e(this).toggleClass(t.classes.hover, "mouseenter" === i.type), t.options.openOnHover && (clearTimeout(t.closeTimer), "mouseleave" === i.type ? t.closeTimer = setTimeout(e.proxy(t.close, t), t.options.hoverIntentTimeout) : t.open())
            }), t.elements.wrapper.on("click.sl", function(e) {
                t.state.opened ? t.close() : t.open(e)
            }), t.options.nativeOnMobile && t.utils.isMobile() || (t.$element.on("focus.sl", function() {
                t.elements.input.focus()
            }), t.elements.input.prop({
                tabindex: t.originalTabindex,
                disabled: !1
            }).on("keydown.sl", e.proxy(t.handleKeys, t)).on("focusin.sl", function(e) {
                t.elements.outerWrapper.addClass(t.classes.focus), t.elements.input.one("blur", function() {
                    t.elements.input.blur()
                }), t.options.openOnFocus && !t.state.opened && t.open(e)
            }).on("focusout.sl", function() {
                t.elements.outerWrapper.removeClass(t.classes.focus)
            }).on("input propertychange", function() {
                var i = t.elements.input.val(),
                    s = new RegExp("^" + t.utils.escapeRegExp(i), "i");
                clearTimeout(t.resetStr), t.resetStr = setTimeout(function() {
                    t.elements.input.val("")
                }, t.options.keySearchTimeout), i.length && e.each(t.items, function(e, i) {
                    (!i.disabled && s.test(i.text) || s.test(i.slug)) && t.highlight(e)
                })
            })), t.$li.on({
                mousedown: function(e) {
                    e.preventDefault(), e.stopPropagation()
                },
                click: function() {
                    return t.select(e(this).data("index")), !1
                }
            })
        },
        handleKeys: function(t) {
            var i = t.which,
                s = this.options.keys,
                o = e.inArray(i, s.previous) > -1,
                n = e.inArray(i, s.next) > -1,
                r = e.inArray(i, s.select) > -1,
                a = e.inArray(i, s.open) > -1,
                c = this.state.highlightedIdx,
                l = o && 0 === c || n && c + 1 === this.items.length,
                d = 0;
            if (13 !== i && 32 !== i || t.preventDefault(), o || n) {
                if (!this.options.allowWrap && l) return;
                o && (d = this.utils.previousEnabledItem(this.lookupItems, c)), n && (d = this.utils.nextEnabledItem(this.lookupItems, c)), this.highlight(d)
            }
            if (r && this.state.opened) return this.select(c), void(this.state.multiple && this.options.multiple.keepMenuOpen || this.close());
            a && !this.state.opened && this.open()
        },
        refresh: function() {
            this.populate(), this.activate(), this.utils.triggerCallback("Refresh", this)
        },
        setOptionsDimensions: function() {
            var e = this.elements.items.closest(":visible").children(":hidden").addClass(this.classes.tempshow),
                t = this.options.maxHeight,
                i = this.elements.items.outerWidth(),
                s = this.elements.wrapper.outerWidth() - (i - this.elements.items.width());
            !this.options.expandToItemText || s > i ? this.finalWidth = s : (this.elements.items.css("overflow", "scroll"), this.elements.outerWrapper.width(9e4), this.finalWidth = this.elements.items.width(), this.elements.items.css("overflow", ""), this.elements.outerWrapper.width("")), this.elements.items.width(this.finalWidth).height() > t && this.elements.items.height(t), e.removeClass(this.classes.tempshow)
        },
        isInViewport: function() {
            var e = i.scrollTop(),
                t = i.height(),
                s = this.elements.outerWrapper.offset().top,
                o = this.elements.outerWrapper.outerHeight(),
                n = "top" != this.options.direction && s + o + this.itemsHeight <= e + t,
                r = "bottom" != this.options.direction && s - this.itemsHeight > e,
                a = !n && r;
            this.elements.outerWrapper.toggleClass(this.classes.above, a)
        },
        detectItemVisibility: function(t) {
            var i = this.$li.filter("[data-index]");
            this.state.multiple && (t = e.isArray(t) && 0 === t.length ? 0 : t, t = e.isArray(t) ? Math.min.apply(Math, t) : t);
            var s = i.eq(t).outerHeight(),
                o = i[t].offsetTop,
                n = this.elements.itemsScroll.scrollTop(),
                r = o + 2 * s;
            this.elements.itemsScroll.scrollTop(r > n + this.itemsHeight ? r - this.itemsHeight : o - s < n ? o - s : n)
        },
        open: function(i) {
            var s = this;
            if (s.options.nativeOnMobile && s.utils.isMobile()) return !1;
            s.utils.triggerCallback("BeforeOpen", s), i && (i.preventDefault(), s.options.stopPropagation && i.stopPropagation()), s.state.enabled && (s.setOptionsDimensions(), e("." + s.classes.hideselect, "." + s.classes.open).children().selectric("close"), s.state.opened = !0, s.itemsHeight = s.elements.items.outerHeight(), s.itemsInnerHeight = s.elements.items.height(), s.elements.outerWrapper.addClass(s.classes.open), s.elements.input.val(""), i && "focusin" !== i.type && s.elements.input.focus(), setTimeout(function() {
                t.on("click.sl", e.proxy(s.close, s)).on("scroll.sl", e.proxy(s.isInViewport, s))
            }, 1), s.isInViewport(), s.options.preventWindowScroll && t.on("mousewheel.sl DOMMouseScroll.sl", "." + s.classes.scroll, function(t) {
                var i = t.originalEvent,
                    o = e(this).scrollTop(),
                    n = 0;
                "detail" in i && (n = -1 * i.detail), "wheelDelta" in i && (n = i.wheelDelta), "wheelDeltaY" in i && (n = i.wheelDeltaY), "deltaY" in i && (n = -1 * i.deltaY), (o === this.scrollHeight - s.itemsInnerHeight && n < 0 || 0 === o && n > 0) && t.preventDefault()
            }), s.detectItemVisibility(s.state.selectedIdx), s.highlight(s.state.multiple ? -1 : s.state.selectedIdx), s.utils.triggerCallback("Open", s))
        },
        close: function() {
            this.utils.triggerCallback("BeforeClose", this), t.off(".sl"), this.elements.outerWrapper.removeClass(this.classes.open), this.state.opened = !1, this.utils.triggerCallback("Close", this)
        },
        change: function() {
            var t = this;
            t.utils.triggerCallback("BeforeChange", t), t.state.multiple ? (e.each(t.lookupItems, function(e) {
                t.lookupItems[e].selected = !1, t.$element.find("option").prop("selected", !1)
            }), e.each(t.state.selectedIdx, function(e, i) {
                t.lookupItems[i].selected = !0, t.$element.find("option").eq(i).prop("selected", !0)
            }), t.state.currValue = t.state.selectedIdx, t.setLabel(), t.utils.triggerCallback("Change", t)) : t.state.currValue !== t.state.selectedIdx && (t.$element.prop("selectedIndex", t.state.currValue = t.state.selectedIdx).data("value", t.lookupItems[t.state.selectedIdx].text), t.setLabel(), t.utils.triggerCallback("Change", t))
        },
        highlight: function(e) {
            var t = this.$li.filter("[data-index]").removeClass("highlighted");
            this.utils.triggerCallback("BeforeHighlight", this), void 0 === e || -1 === e || this.lookupItems[e].disabled || (t.eq(this.state.highlightedIdx = e).addClass("highlighted"), this.detectItemVisibility(e), this.utils.triggerCallback("Highlight", this))
        },
        select: function(t) {
            var i = this,
                s = i.$li.filter("[data-index]");
            if (i.utils.triggerCallback("BeforeSelect", i, t), void 0 !== t && -1 !== t && !i.lookupItems[t].disabled) {
                if (i.state.multiple) {
                    i.state.selectedIdx = e.isArray(i.state.selectedIdx) ? i.state.selectedIdx : [i.state.selectedIdx];
                    var o = e.inArray(t, i.state.selectedIdx); - 1 !== o ? i.state.selectedIdx.splice(o, 1) : i.state.selectedIdx.push(t), s.removeClass("selected").filter(function(t) {
                        return -1 !== e.inArray(t, i.state.selectedIdx)
                    }).addClass("selected")
                } else s.removeClass("selected").eq(i.state.selectedIdx = t).addClass("selected");
                i.state.multiple && i.options.multiple.keepMenuOpen || i.close(), i.change(), i.utils.triggerCallback("Select", i, t)
            }
        },
        destroy: function(e) {
            this.state && this.state.enabled && (this.elements.items.add(this.elements.wrapper).add(this.elements.input).remove(), e || this.$element.removeData("selectric").removeData("value"), this.$element.prop("tabindex", this.originalTabindex).off(".sl").off(this.eventTriggers).unwrap().unwrap(), this.state.enabled = !1)
        }
    }, e.fn.selectric = function(t) {
        return this.each(function() {
            var i = e.data(this, "selectric");
            i && !i.disableOnMobile ? "string" == typeof t && i[t] ? i[t]() : i.init(t) : e.data(this, "selectric", new n(this, t))
        })
    }, e.fn.selectric.defaults = {
        onChange: function(t) {
            e(t).change()
        },
        maxHeight: 300,
        keySearchTimeout: 500,
        arrowButtonMarkup: '<b class="button">&#x25be;</b>',
        disableOnMobile: !1,
        nativeOnMobile: !0,
        openOnFocus: !0,
        openOnHover: !1,
        hoverIntentTimeout: 500,
        expandToItemText: !1,
        responsive: !1,
        preventWindowScroll: !0,
        inheritOriginalWidth: !1,
        allowWrap: !0,
        stopPropagation: !0,
        optionsItemBuilder: "{text}",
        labelBuilder: "{text}",
        listBuilder: !1,
        keys: {
            previous: [37, 38],
            next: [39, 40],
            select: [9, 13, 27],
            open: [13, 32, 37, 38, 39, 40],
            close: [9, 27]
        },
        customClass: {
            prefix: "selectric",
            camelCase: !1
        },
        multiple: {
            separator: ", ",
            keepMenuOpen: !0,
            maxLabelEntries: !1
        },
        direction: "auto"
    }
}), window.theme = window.theme || {}, window.theme.version = "1.6.0", theme.cacheSelectors = function() {
        theme.cache = {
            $window: $(window),
            $html: $("html"),
            $body: $(document.body),
            $recoverPasswordForm: $("#RecoverPasswordForm"),
            $customerLoginForm: $("#CustomerLoginForm"),
            $recoverPasswordLink: $("#RecoverPassword"),
            $hideRecoverPasswordLink: $("#HideRecoverPasswordLink"),
            $passwordResetSuccess: $("#ResetSuccess")
        }, theme.mobileBreakpoint = 1024, theme.isMobile = function() {
            return theme.cache.$body.width() < this.mobileBreakpoint
        }, theme.isDesktop = function() {
            return theme.cache.$body.width() >= this.mobileBreakpoint
        }, theme.smoothScroll = function(e, t, i) {
            t || (t = 1e3), i || (i = 0), $("html, body").animate({
                scrollTop: e.offset().top + i
            }, t)
        }
    }, theme.sliders = {}, theme.debug = {}, theme.getHash = function() {
        return window.location.hash
    }, theme.Currency = function() {
        var e = "$";
        return {
            formatMoney: function(t, i) {
                "string" == typeof t && (t = t.replace(".", ""));
                var s = "",
                    o = /\{\{\s*(\w+)\s*\}\}/,
                    n = i || e;

                function r(e, t, i, s) {
                    if (t = t || 2, i = i || ",", s = s || ".", isNaN(e) || null == e) return 0;
                    var o = (e = (e / 100).toFixed(t)).split(".");
                    return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (o[1] ? s + o[1] : "")
                }
                switch (n.match(o)[1]) {
                    case "amount":
                        s = r(t, 2);
                        break;
                    case "amount_no_decimals":
                        s = r(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        s = r(t, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        s = r(t, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        s = r(t, 0, " ")
                }
                return n.replace(o, s)
            }
        }
    }(), theme.currencySymbols = {
        AED: "د.إ",
        AFN: "؋",
        ALL: "L",
        ANG: "ƒ",
        AOA: "Kz",
        ARS: "$",
        AUD: "$",
        AWG: "ƒ",
        AZN: "₼",
        BAM: "KM",
        BBD: "$",
        BDT: "৳",
        BGN: "лв",
        BHD: ".د.ب",
        BIF: "FBu",
        BMD: "$",
        BND: "$",
        BOB: "Bs.",
        BRL: "R$",
        BSD: "$",
        BTC: "฿",
        BTN: "Nu.",
        BWP: "P",
        BYR: "p.",
        BZD: "BZ$",
        CAD: "$",
        CDF: "FC",
        CHF: "Fr.",
        CLP: "$",
        CNY: "¥",
        COP: "$",
        CRC: "₡",
        CUC: "$",
        CUP: "₱",
        CVE: "$",
        CZK: "Kč",
        DJF: "Fdj",
        DKK: "kr",
        DOP: "RD$",
        DZD: "دج",
        EEK: "kr",
        EGP: "£",
        ERN: "Nfk",
        ETB: "Br",
        EUR: "€",
        FJD: "$",
        FKP: "£",
        GBP: "£",
        GEL: "₾",
        GGP: "£",
        GHC: "₵",
        GHS: "GH₵",
        GIP: "£",
        GMD: "D",
        GNF: "FG",
        GTQ: "Q",
        GYD: "$",
        HKD: "$",
        HNL: "L",
        HRK: "kn",
        HTG: "G",
        HUF: "Ft",
        IDR: "Rp",
        ILS: "₪",
        IMP: "£",
        INR: "₹",
        IQD: "ع.د",
        IRR: "﷼",
        ISK: "kr",
        JEP: "£",
        JMD: "J$",
        JPY: "¥",
        KES: "KSh",
        KGS: "лв",
        KHR: "៛",
        KMF: "CF",
        KPW: "₩",
        KRW: "₩",
        KYD: "$",
        KZT: "₸",
        LAK: "₭",
        LBP: "£",
        LKR: "₨",
        LRD: "$",
        LSL: "M",
        LTL: "Lt",
        LVL: "Ls",
        MAD: "MAD",
        MDL: "lei",
        MGA: "Ar",
        MKD: "ден",
        MMK: "K",
        MNT: "₮",
        MOP: "MOP$",
        MUR: "₨",
        MVR: "Rf",
        MWK: "MK",
        MXN: "$",
        MYR: "RM",
        MZN: "MT",
        NAD: "$",
        NGN: "₦",
        NIO: "C$",
        NOK: "kr",
        NPR: "₨",
        NZD: "$",
        OMR: "﷼",
        PAB: "B/.",
        PEN: "S/.",
        PGK: "K",
        PHP: "₱",
        PKR: "₨",
        PLN: "zł",
        PYG: "Gs",
        QAR: "﷼",
        RMB: "￥",
        RON: "lei",
        RSD: "Дин.",
        RUB: "₽",
        RWF: "R₣",
        SAR: "﷼",
        SBD: "$",
        SCR: "₨",
        SDG: "ج.س.",
        SEK: "kr",
        SGD: "$",
        SHP: "£",
        SLL: "Le",
        SOS: "S",
        SRD: "$",
        SSP: "£",
        STD: "Db",
        SVC: "$",
        SYP: "£",
        SZL: "E",
        THB: "฿",
        TJS: "SM",
        TMT: "T",
        TND: "د.ت",
        TOP: "T$",
        TRL: "₤",
        TRY: "₺",
        TTD: "TT$",
        TVD: "$",
        TWD: "NT$",
        TZS: "TSh",
        UAH: "₴",
        UGX: "USh",
        USD: "$",
        UYU: "$U",
        UZS: "лв",
        VEF: "Bs",
        VND: "₫",
        VUV: "VT",
        WST: "WS$",
        XAF: "FCFA",
        XBT: "Ƀ",
        XCD: "$",
        XOF: "CFA",
        XPF: "₣",
        YER: "﷼",
        ZAR: "R",
        ZWD: "Z$"
    }, theme.Sections = function() {
        this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
    }, theme.Sections.prototype = _.extend({}, theme.Sections.prototype, {
        _createInstance: function(e, t) {
            var i = $(e),
                s = i.attr("data-section-id"),
                o = i.attr("data-section-type");
            if (t = t || this.constructors[o], !_.isUndefined(t)) {
                var n = _.extend(new t(e), {
                    id: s,
                    type: o,
                    container: e
                });
                this.instances.push(n), _.isFunction(n.onLoad) && n.onLoad()
            }
        },
        _onSectionLoad: function(e) {
            var t = $("[data-section-id]", e.target)[0];
            t && this._createInstance(t)
        },
        _onSectionUnload: function(e) {
            this.instances = _.filter(this.instances, function(t) {
                var i = t.id === e.detail.sectionId;
                return i && _.isFunction(t.onUnload) && t.onUnload(e), !i
            })
        },
        _onSelect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e)
        },
        _onDeselect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e)
        },
        _onBlockSelect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e)
        },
        _onBlockDeselect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockDeselect) && t.onBlockDeselect(e)
        },
        register: function(e, t) {
            this.constructors[e] = t, $("[data-section-type=" + e + "]").each(function(e, i) {
                this._createInstance(i, t)
            }.bind(this))
        }
    }), theme.Variants = function() {
        var curBwpVariant, pageIsLoaded = 0;;
        function e(e) {
            setTimeout(()=>{
              var qtyBtns = document.querySelectorAll(".js-qty__adjust");
              document.querySelector("#ced-bwp [name='quantity']").addEventListener("change", function(){
                var qty = this.value;
                window.bwp && window.bwp.updateWidget(curBwpVariant.sku,  +qty > 0 ? +qty : 1, []);
              });
              
              qtyBtns.forEach((ele) => {
                ele.addEventListener("click", function(){
                  var qty = document.querySelector("#ced-bwp [name='quantity']").value;
                  window.bwp && window.bwp.updateWidget(curBwpVariant.sku,  +qty > 0 ? +qty : 1, []);
                });
              });
            }, 1000);

            const myInterval = setInterval(() => {
              if(window.readyState === "complete"){
                clearInterval(myInterval);
                setTimeout(()=>{
                  var bwpBtn = document.querySelector(".bwp-widget-loaded");
                  var isBwpEnabled = document.querySelector("#isBwpEnabled");
                  if(isBwpEnabled == "true"){
                    if(bwpBtn === null){
                      document.querySelector("#bwp-error-msg").innerText = "*This variant is not available for Buy with prime";
                    }
                    else{
                      document.querySelector("#bwp-error-msg").innerText = "";
                    }
                  }
                  // console.log(bwpBtn, "676");
                }, 1000);
              }
            }, 1000);
            return this.$container = e.$container, this.product = e.product, this.singleOptionSelector = e.singleOptionSelector, this.originalSelectorId = e.originalSelectorId, this.enableHistoryState = e.enableHistoryState, this.currentVariant = this._getVariantFromUrl(), this.currentVariant || (this.currentVariant = this._getVariantFromOptions()), $(this.$container).on("change", $(this.singleOptionSelector), this._onSelectChange.bind(this)), this.currentVariant
        }
        return e.prototype = _.extend({}, e.prototype, {
            _getCurrentOptions: function() {
                var e = this.singleOptionSelector + ":visible",
                    t = _.map($(e, this.$container), function(e) {
                        var t = $(e),
                            i = t.attr("type"),
                            s = {};
                        return "radio" === i || "checkbox" === i ? !!t[0].checked && (s.value = t.val(), s.index = t.data("option"), s) : (s.value = t.val(), s.index = t.data("option"), s)
                    });
                return t = _.compact(t)
            },
            _getVariantFromOptions: function() {
                var e = this._getCurrentOptions(),
                    t = this.product.variants;
                return _.find(t, function(t) {
                    return e.every(function(e) {
                        return _.isEqual(t[e.index], e.value)
                    })
                })
            },
            _getVariantFromUrl: function() {
                var e = null;
                return match = window.location.search.match(/variant=(\d+)/i), match && match[1] && (e = _.find(this.product.variants, function(e) {
                    return _.isEqual(match[1], e.id + "")
                })), e
            },
            _onSelectChange: function(e) {
                if (!e.target || "#" + $(e.target).attr("id") != this.originalSelectorId) {
                    var t = this._getVariantFromOptions();
                    document.querySelector("#bwp-error-msg").innerText = ""
                    curBwpVariant=t;
                    var variantQty = document.querySelector("#ced-bwp [name='quantity']").value;
                    var variantSku = t.sku;
                    window.bwp && window.bwp.updateWidget(variantSku,  +variantQty > 0 ? +variantQty : 1, []);
                    // console.log(variantQty, document.querySelector(".product-quantity__content-desktop #Quantity").value);
                    
                    const myInterval = setInterval(() => {
                      if(document.readyState === "complete"){
                        clearInterval(myInterval);
                        pageIsLoaded = 1;
                        setTimeout(()=>{
                          var bwpBtn = document.querySelector(".bwp-widget-loaded");
                          var isBwpEnabled = document.querySelector("#isBwpEnabled").value;
                          if(isBwpEnabled == "true"){
                            if(bwpBtn === null){
                              document.querySelector("#bwp-error-msg").innerText = "*This variant is not available for Buy with prime";
                            }
                            else{
                              document.querySelector("#bwp-error-msg").innerText = "";
                            }
                          }
                          // console.log(bwpBtn, "676");
                        }, 1000);
                      }
                      else if(pageIsLoaded > 0){
                        clearInterval(myInterval);
                        setTimeout(()=>{
                          var bwpBtn = document.querySelector(".bwp-widget-loaded");
                          var isBwpEnabled = document.querySelector("#isBwpEnabled").value;
                          if(isBwpEnabled == "true"){
                            if(bwpBtn === null){
                              document.querySelector("#bwp-error-msg").innerText = "*This variant is not available for Buy with prime";
                            }
                            else{
                              document.querySelector("#bwp-error-msg").innerText = "";
                            }
                          }
                          console.log(bwpBtn, "676", pageIsLoaded);
                        }, 100);
                      }
                      console.log(pageIsLoaded, document.readyState);
                      
                    }, 1000);
                    // setTimeout(()=>{
                    //   var bwpBtn = document.querySelector(".bwp-widget-loaded");
                    //   if(bwpBtn === null){
                    //     document.querySelector("#bwp-error-msg").innerText = "This variant is not available for Buy with prime";
                    //   }
                    //   else{
                    //     document.querySelector("#bwp-error-msg").innerText = "";
                    //   }
                    //   console.log(bwpBtn, "725");
                    // }, 1000);
                    this.currentVariant && t && this.currentVariant.id == t.id || (this.$container.trigger({
                        type: "variantChange",
                        variant: t
                    }), t && (this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), this._updateSKU(t), this.currentVariant = t, this.enableHistoryState && this._updateHistoryState(t)))
                }
            },
            _updateImages: function(e) {
                var t = e.featured_image || {},
                    i = this.currentVariant.featured_image || {};
                e.featured_image && t.src !== i.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: e
                })
            },
            _updatePrice: function(e) {
                e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                    type: "variantPriceChange",
                    variant: e
                })
            },
            _updateSKU: function(e) {
                e.sku !== this.currentVariant.sku && this.$container.trigger({
                    type: "variantSKUChange",
                    variant: e
                })
            },
            _updateHistoryState: function(e) {
                if (history.replaceState && e) {
                    var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                    window.history.replaceState({
                        path: t
                    }, "", t)
                }
            },
            _updateMasterSelect: function(e) {
                $(this.originalSelectorId, this.$container).val(e.id)
            }
        }), e
    }(), theme.loginForms = function() {
        function e() {
            theme.cache.$recoverPasswordForm.show(), theme.cache.$customerLoginForm.hide()
        }
        theme.cache.$recoverPasswordLink.on("click", function(t) {
            t.preventDefault(), e()
        }), theme.cache.$hideRecoverPasswordLink.on("click", function(e) {
            e.preventDefault(), theme.cache.$recoverPasswordForm.hide(), theme.cache.$customerLoginForm.show()
        }), "#recover" == theme.getHash() && e()
    }, theme.resetPasswordSuccess = function() {
        theme.cache.$passwordResetSuccess.show()
    }, theme.setupMap = function(e) {
        function t(e) {
            var s = $(this);
            s.on("click", i), s.off("mouseleave", t), s.find("iframe").css("pointer-events", "none")
        }

        function i(e) {
            var s = $(this);
            s.off("click", i), s.find("iframe").css("pointer-events", "auto"), s.on("mouseleave", t)
        }
        e.find(".map .map__wrapper").on("click", i)
    }, theme.CookieManager = function() {
        var e = function() {};
        return e.prototype.set = function(e, t, i) {
            var s = new Date;
            s.setTime(s.getTime() + 24 * i * 60 * 60 * 1e3);
            var o = "expires=" + s.toUTCString();
            document.cookie = e + "=" + t + ";" + o + ";path=/"
        }, e.prototype.get = function(e) {
            for (var t = e + "=", i = decodeURIComponent(document.cookie).split(";"), s = 0; s < i.length; s++) {
                for (var o = i[s];
                    " " == o.charAt(0);) o = o.substring(1);
                if (0 == o.indexOf(t)) return o.substring(t.length, o.length)
            }
            return ""
        }, e.prototype.check = function(e) {
            var t = this.get(e);
            return "" != t && null != t
        }, e.prototype.remove = function(e) {
            var t = new Date;
            t.setTime(t.getTime() + -864e8);
            var i = "expires=" + t.toUTCString();
            document.cookie = e + "=deleted;" + i + ";path=/"
        }, e
    }(), theme.productCardsInit = function(e) {
        var t = ".product-form__variants",
            i = ".product-form";
        e.find(".product-card " + t).unbind("change").on("change", function(e) {
            var s = $(this).parents(".product-card").first();
            s.find(i).trigger("submit"), setTimeout(function() {
                var e = s.find(t);
                e.hasClass("product-form__variants--has-variants") && e.prop("selectedIndex", 0).selectric("refresh")
            }, 500)
        }), e.find(".product-card--hoverable " + t + ":not(.hide)").selectric({
            maxHeight: 145,
            openOnHover: !0,
            direction: "bottom",
            hoverIntentTimeout: 200
        }), e.find(".product-card--no-hover " + t + ":not(.hide)").selectric({
            maxHeight: 210,
            openOnHover: !1,
            direction: "top"
        })
    }, theme.Drawers = function() {
        var e = function(e, t, i) {
            var s = {
                close: ".js-drawer-close",
                open: ".js-drawer-open-" + t,
                openClass: "js-drawer-open",
                dirOpenClass: "js-drawer-open-" + t
            };
            if (this.mobileBreakpoint = 1024, this.$nodes = {
                    parent: $("body, html"),
                    page: $("#page_container"),
                    moved: $(".is-moved-by-drawer")
                }, this.config = $.extend(s, i), this.position = t, this.$drawer = $("#" + e), !this.$drawer.length) return !1;
            this.drawerIsOpen = !1, this.init()
        };
        return e.prototype.init = function() {
            $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.find(this.config.close).on("click", $.proxy(this.close, this));
            var e = this;
            theme.closeCartDrawer = function() {
                e.close()
            }
        }, e.prototype.open = function(e) {
            var t = !1;
            if (e ? e.preventDefault() : t = !0, e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = $(e.currentTarget)), this.drawerIsOpen && !t) return this.close();
            theme.cache.$body.trigger("beforeDrawerOpen.theme", this), this.$nodes.moved.addClass("is-transitioning"), this.$drawer.prepareTransition(), this.$nodes.parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, theme.cache.$body.width() < this.mobileBreakpoint && this.trapFocus(this.$drawer, "drawer_focus"), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (t || this.config.onDrawerOpen()), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.$nodes.page.on("touchmove.drawer", function() {
                return !1
            }), this.$nodes.page.on("click.drawer", $.proxy(function() {
                return this.close(), !1
            }, this)), theme.cache.$body.trigger("afterDrawerOpen.theme", this)
        }, e.prototype.close = function() {
            this.drawerIsOpen && (theme.cache.$body.trigger("beforeDrawerClose.theme", this), $(document.activeElement).trigger("blur"), this.$nodes.moved.prepareTransition({
                disableExisting: !0
            }), this.$drawer.prepareTransition({
                disableExisting: !0
            }), this.$nodes.parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, this.removeTrapFocus(this.$drawer, "drawer_focus"), this.$nodes.page.off(".drawer"), theme.cache.$body.trigger("afterDrawerClose.theme", this))
        }, e.prototype.trapFocus = function(e, t) {
            var i = t ? "focusin." + t : "focusin";
            e.attr("tabindex", "-1"), e.focus(), $(document).on(i, function(t) {
                e[0] === t.target || e.has(t.target).length || e.focus()
            })
        }, e.prototype.removeTrapFocus = function(e, t) {
            var i = t ? "focusin." + t : "focusin";
            e.removeAttr("tabindex"), $(document).off(i)
        }, e
    }(), theme.drawersInit = function() {
        theme.DesktopLeftDrawer = new theme.Drawers("DesktopNavDrawer", "desktop-left"), theme.LeftDrawer = new theme.Drawers("NavDrawer", "left"), theme.RightDrawer = new theme.Drawers("CartDrawer", "right", {
            onDrawerOpen: ajaxCart.load
        }), theme.cache.$body.on("beforeDrawerOpen.theme", function() {
            theme.LeftDrawer.drawerIsOpen ? theme.LeftDrawer.close() : theme.RightDrawer.drawerIsOpen ? theme.RightDrawer.close() : theme.DesktopLeftDrawer.drawerIsOpen && theme.DesktopLeftDrawer.close()
        })
    }, theme.Modal = function() {
        var e = function(e) {
            this.config = {
                open: ".js-modal-open",
                close: ".js-modal-close"
            };
            this.ID = e, this.$modal = $("#" + this.ID), this.modalIsOpen = !1, this.init()
        };
        return e.prototype.init = function() {
            var e = this;
            $(document).on("click.show-" + this.ID, this.config.open + "-" + this.ID, $.proxy(this.show, this)), $(document).on("click.hide-" + this.ID, this.config.close, $.proxy(this.hide, this)), $(document).on("click.close-" + this.ID, function(t) {
                t.target == e.$modal[0] && e.hide()
            })
        }, e.prototype.show = function(e) {
            e ? e.preventDefault() : externalCall = !0, this.$modal.css({
                display: "block"
            }), this.modalIsOpen = !0, ajaxCart.load()
        }, e.prototype.onlyShow = function(e) {
            this.$modal.css({
                display: "block"
            }), this.modalIsOpen = !0
        }, e.prototype.hide = function(e) {
            this.$modal.css({
                display: "none"
            }), this.modalIsOpen = !1
        }, e
    }(), theme.modalInit = function() {
        $("#CartModal").length > 0 && (theme.cartModal = new theme.Modal("CartModal")), $("#SplashModal").length > 0 && (theme.SplashModalEl = new theme.Modal("SplashModal")), $("#ShippingModal").length > 0 && (theme.ShippingModal = new theme.Modal("ShippingModal"))
    }, theme.splashModals = function() {
        var e = {
                modal: "#SplashModal"
            },
            t = $(e.modal).data("days-hidden"),
            i = 1e3 * $(e.modal).data("showup-delay"),
            s = $(e.modal).data("test-mode"),
            o = $(e.modal).find(".modal-content"),
            n = o.data("explosive-offer"),
            r = o.data("explosion-gif"),
            a = "konversion-modals",
            c = new theme.CookieManager;

        function l() {
            setTimeout(function() {
                theme.SplashModalEl.onlyShow(), n && (o.css("transform", "scale(0)"), $(e.modal).css("background-image", "url(" + r + ")").css("background-size", "cover").css("background-repeat", "no-repeat").css("background-position", "50% 50%"), setTimeout(function() {
                    o.css("transform", "scale(1)"), setTimeout(function() {
                        $(e.modal).css("background", "rgba(0, 0, 0, 0.4)")
                    }, 1e3)
                }, 1500))
            }, i)
        }
        c.check(a) ? "open" == c.get(a) && (c.set(a, "closed", t), l()) : (c.set(a, "open", t), l()), theme.adminSet && s && l()
    }, theme.Swatches = function() {
        var e = function(e) {
            this.$swatch = $(e), this.$form = this.$swatch.parents("form").first(), this.$swatch.find("input").on("change", $.proxy(this.onChange, this))
        };
        return e.prototype.onChange = function(e) {
            var t = $(e.target),
                i = this.$swatch.data("index"),
                s = t.val();
            this.$swatch.find(".swatches__option").removeClass("swatches__option--selected"), t.parents(".swatches__option").first().addClass("swatches__option--selected"), this.$form.find(".single-option-selector[data-option=option" + i + "]").val(s).trigger("change")
        }, e
    }(), theme.initSwatches = function() {
        $(".swatches").each(function(e, t) {
            new theme.Swatches(t)
        }), $('[data-color-tooltip!=""]').qtip({
            content: {
                attr: "data-color-tooltip"
            },
            style: {
                classes: "qtip-light qtip-shadow"
            },
            position: {
                my: "top left",
                at: "bottom left"
            }
        })
    }, theme.mobileNavInit = function() {
        $(".mobileMenu").mmenu({
            offCanvas: !1
        })
    }, theme.instaFeedInit = function() {
        $(".instagram-feed").each(function() {
            var e = $("#" + $(this).attr("id")),
                t = e.data("image-per-row-desktop"),
                i = e.data("image-per-row-mobile"),
                s = e.data("hover-effect") ? "hover-effect" : "";
            if (!e || e && e.length <= 0) return !1;
            var o = {
                target: $(this).attr("id"),
                get: e.data("get"),
                resolution: e.data("resolution-images"),
                clientId: e.data("client-id"),
                limit: e.data("limit"),
                tagName: e.data("tag"),
                locationId: e.data("location-id"),
                after: function(o) {
                    switch (e.data("image-show-type")) {
                        case "link":
                            e.find("a").attr("target", "_blank");
                            break;
                        case "gallery":
                            e.find("a").addClass("fancybox"), e.find("a").each(function() {
                                $(this).attr("href", $(this).find("img").attr("src")), $(this).attr("rel", e.data("feed-id"))
                            });
                            break;
                        case "nothing":
                            e.find("a").attr("href", "javascript:;")
                    }
                    e.find("a").wrap("<div class='grid__item text-center " + s + " " + i + " " + t + "'></div>"), e.find("img").css("max-height", e.find(".grid__item").width() + "px")
                },
                error: function(t) {
                    e.next().addClass("instagram-feed_placeholders--visible")
                }
            };
            "" != e.data("tag") && (o.tagName = e.data("tag")), "" != e.data("location-id") && (o.locationId = e.data("location-id")), "" != e.data("user-id") && (o.userId = e.data("user-id")), "" != e.data("access-token") && (o.accessToken = e.data("access-token")), new Instafeed(o).run()
        }), $(".fancybox").fancybox({
            nextEffect: "fade",
            prevEffect: "fade"
        })
    },
    function(e) {
        "use strict";
        var t = e.document;

        function i(e, t) {
            this.el = e, this.options = function(e, t) {
                for (var i in t) t.hasOwnProperty(i) && (e[i] = t[i]);
                return e
            }(this.defaults, t), this._init()
        }
        i.prototype = {
            defaults: {},
            _init: function() {
                this.current = -1, this.touch = Modernizr.touch, this.menu = this.el.querySelector(".cbp-hsmenu"), this.menuItems = this.el.querySelectorAll(".cbp-hsmenu > li"), this.menuBg = t.createElement("div"), this.menuBg.className = "cbp-hsmenubg", this.el.appendChild(this.menuBg), this._initEvents()
            },
            _openMenu: function(e, t) {
                var i = this,
                    s = e.parentNode,
                    o = Array.prototype.slice.call(this.menuItems),
                    n = s.querySelector(".cbp-hssubmenu"),
                    r = function(e) {
                        (e = e || i.menuItems[i.current]).className = "", e.setAttribute("data-open", "")
                    },
                    a = function() {
                        i.current = -1, i.menuBg.style.height = "0px"
                    },
                    c = $(n).offset().left;
                0 != c && $(n).css("margin-left", -c), n ? (t.preventDefault(), "open" === s.getAttribute("data-open") ? (r(s), a()) : (s.setAttribute("data-open", "open"), -1 !== i.current && r(), i.current = o.indexOf(s), s.className = "cbp-hsitem-open", i.menuBg.style.height = n.offsetHeight + "px")) : -1 !== i.current && (r(), a())
            },
            _initEvents: function() {
                var t = this;
                Array.prototype.slice.call(this.menuItems).forEach(function(e, i) {
                    var s = e.querySelector("a");
                    t.touch ? s.addEventListener("touchstart", function(e) {
                        t._openMenu(this, e)
                    }) : (s.addEventListener("click", function(e) {
                        t._openMenu(this, e)
                    }), s.addEventListener("mouseover", function(e) {
                        t._openMenu(this, e)
                    }))
                }), e.addEventListener("resize", function(e) {
                    t._resizeHandler()
                })
            },
            _resizeHandler: function() {
                var e = this;
                this._resizeTimeout && clearTimeout(this._resizeTimeout), this._resizeTimeout = setTimeout(function() {
                    e._resize(), e._resizeTimeout = null
                }, 50)
            },
            _resize: function() {
                -1 !== this.current && (this.menuBg.style.height = this.menuItems[this.current].querySelector(".cbp-hssubmenu").offsetHeight + "px")
            }
        }, e.cbpHorizontalSlideOutMenu = i
    }(window), theme.HeaderSection = function() {
        function e(e) {
            var t;
            if (this.$container = t = this.$container = $(e), "text-menu" == t.data("menu-type")) t.find("ul.sf-menu").superfish({
                delay: 500,
                speed: 200
            });
            else new cbpHorizontalSlideOutMenu(document.getElementById("cbp-hsmenu-wrapper"));
            t.find(".js-expand-search").on("click", this._toggleSearchField.bind(this));
            var i = this;
            t.find(".header-search").on("keyup", function(e) {
                "Escape" === e.key && i._toggleSearchField()
            })
        }
        return e.prototype = _.extend({}, e.prototype, {
            _toggleSearchField: function() {
                $search = this.$container.find(".header-search"), $search.hasClass("header-search--active") ? $search.removeClass("header-search--active") : ($search.addClass("header-search--active"), $search.find("input").focus())
            },
            onUnload: function() {
                this.cleanUp()
            },
            cleanUp: function() {}
        }), e
    }(), theme.Slideshow = function() {
        this.$slideshow = null;
        var e = {
            wrapper: "slideshow-wrapper",
            slideshow: "slideshow",
            currentSlide: "slick-current"
        };
        return function(t) {
            this.$slideshow = $(t), this.$wrapper = this.$slideshow.closest("." + e.wrapper), this.$pause = this.$wrapper.find("." + e.pauseButton), this.settings = {
                accessibility: !0,
                arrows: !1,
                dots: !0,
                fade: !0,
                draggable: !0,
                touchThreshold: 20,
                autoplay: this.$slideshow.data("autoplay"),
                autoplaySpeed: this.$slideshow.data("speed")
            }, this.$slideshow.slick(this.settings)
        }
    }(), theme.slideshows = {}, theme.SlideshowSection = function() {
        return function(e) {
            var t = (this.$container = $(e)).attr("data-section-id"),
                i = this.slideshow = ".slideshow_" + t;
            theme.slideshows[i] = new theme.Slideshow(i)
        }
    }(), theme.SlideshowSection.prototype = _.extend({}, theme.SlideshowSection.prototype, {
        onUnload: function() {
            delete theme.slideshows[this.slideshow]
        },
        onBlockSelect: function(e) {
            var t = $(this.slideshow),
                i = $(".slideshow__slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
            t.slick("slickGoTo", i).slick("slickPause")
        },
        onBlockDeselect: function() {
            $(this.slideshow).slick("slickPlay")
        }
    }), theme.Slider = function() {
        this.$slider = null;
        var e = {
            wrapper: "slider-wrapper",
            slider: "slider",
            currentSlide: "slick-current"
        };
        return function(t, i) {
            this.$slider = $(t), this.$wrapper = this.$slider.closest("." + e.wrapper), this.$pause = this.$wrapper.find("." + e.pauseButton);
            var s = this.$slider.data("content-slider");
            this.settings = {
                dots: !!this.$slider.data("slider-dots"),
                fade: "fade" == this.$slider.data("slider-effect"),
                speed: 500,
                infinite: !0,
                speed: 300,
                slidesToShow: s ? 1 : 4,
                slidesToScroll: s ? 1 : 4,
                autoplay: !0,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: s ? 1 : 3,
                        slidesToScroll: s ? 1 : 3
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: s ? 1 : 2,
                        slidesToScroll: s ? 1 : 2
                    }
                }]
            }, this.$slider.slick(this.settings), theme.productCardsInit(this.$wrapper);
            var o = i.find(".no-slider--grid");
            o.length > 0 && theme.productCardsInit(o)
        }
    }(), theme.sliders = {}, theme.SliderSection = function() {
        return function(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id"),
                s = this.slider = "#slider_" + i;
            theme.sliders[s] = new theme.Slider(s, t)
        }
    }(), theme.SliderSection.prototype = _.extend({}, theme.SliderSection.prototype, {
        onUnload: function() {
            delete theme.sliders[this.slider]
        },
        onBlockSelect: function(e) {
            var t = $(this.slider),
                i = $(".slider__slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
            t.slick("slickGoTo", i).slick("slickPause")
        },
        onBlockDeselect: function() {
            $(this.slider).slick("slickPlay")
        }
    }), theme.ProductImagesSlider = function() {
        this.$sliderThumbs = null, this.$sliderImage = null;
        var e = {
            thumbs: "js-product-thumbs",
            image: "js-product-image"
        };
        return function(t) {
            if ($wrapper = $(t), $wrapper.hasClass("product-images--single")) return !1;
            var i = $wrapper.attr("id");
            this.$sliderThumbs = $wrapper.find("." + e.thumbs), this.$sliderImage = $wrapper.find("." + e.image), this.thumbsSettings = {
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: "#" + i + " ." + e.image,
                dots: !1,
                arrows: this.$sliderThumbs.data("arrows"),
                centerMode: !1,
                focusOnSelect: !0,
                vertical: this.$sliderThumbs.data("vertical"),
                swipeToSlide: this.$sliderThumbs.data("swipe")
            }, this.$sliderThumbs.data("vertical") ? this.thumbsSettings.verticalSwiping = this.$sliderThumbs.data("swipe") : this.thumbsSettings.swipe = this.$sliderThumbs.data("swipe"), this.imageSettings = {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: this.$sliderImage.data("arrows"),
                dots: this.$sliderThumbs.data("thumbs-dot"),
                asNavFor: "#" + i + " ." + e.thumbs,
                swipe: this.$sliderImage.data("swipe"),
                swipeToSlide: this.$sliderImage.data("swipe")
            }, this.$sliderThumbs.slick(this.thumbsSettings), this.$sliderImage.slick(this.imageSettings)
        }
    }(), theme.RelatedProductsSlider = function() {
        this.$relSlider = null;
        return function(e) {
            this.$relSlider = $(e), this.settings = {
                dots: !1,
                fade: !1,
                speed: 500,
                infinite: !0,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }]
            }, this.$relSlider.slick(this.settings)
        }
    }(), theme.ProductPageSection = function() {
        return function(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id"),
                s = this;
            this.theProduct = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML), this.settings = {
                sectionId: i,
                enableHistoryState: t.data("enable-history-state") || !1,
                mobileSize: 1024
            }, this.selectors = {
                originalSelectorId: "#ProductSelect-" + i + "--desktop",
                singleOptionSelector: ".single-option-selector",
                addToCart: "#" + i + " .product-info .product-form-wrapper .product-form__cart-submit",
                addToCartText: "#" + i + " .product-info .product-form-wrapper .product-form__cart-submit-text",
                productPrices: ".product-info .product-price",
                originalPrice: ".product-info .product-price__price",
                comparePrice: ".product-info .product-price__old",
                discountPercent: ".product-info .product-price__percent",
                salePriceWrapper: ".product-info .product-price__sale",
                SKU: ".variant-sku",
                qty: ".variant-qty",
                inPageCartButton: "#" + i + " .product-form__cart",
                stickyBtnStart: "#" + i + " .js-sticky-btn-start",
                stickyCartButton: "#" + i + " .product-form__cart--sticky",
                stickyCartButtonText: "#" + i + " .product-form__cart--sticky button > span.btn-text",
                cartFormMobile: "#" + i + " .product-form--mobile",
                readMoreBtn: ".product-template .product-info__more",
                productDescription: ".product-template .product-info__description",
                productFullDescription: ".product-template .product-info__full_description",
                accordion: "#" + i + " .accordion",
                productInfo: ".product-info",
                productVariants: ".content-product-variants",
                productInfoDesktop: ".product-template .product-info-desktop",
                productInfoMobile: ".product-info-mobile",
                addToCartBar: ".product-add-to-cart-bar ",
                addToCartBarBtn: ".product-add-to-cart-bar .btn--add-to-cart",
                addToCartBarBtnText: ".product-add-to-cart-bar .btn--add-to-cart .product-form__cart-submit-text",
                addToCartBarPrice: ".product-add-to-cart-bar .product-price",
                countDownOffer: ".countdown-offer-clock"
            };
            var o = this.slider = "#" + i + "_images";
            theme.sliders[o] = new theme.ProductImagesSlider(o);
            var n = this.relSlider = "#slider_related-products";
            theme.sliders[n] = new theme.RelatedProductsSlider(n), theme.productCardsInit(t), t.find(".product-images--single .product-images__image, .product-images__image li").each(function(e, t) {
                var i = $(t).find(".zoom"),
                    s = i.data("zoom-status"),
                    o = i.data("zoom-setting");
                if (0 != s) var n = i.magnify({
                    magnifiedWidth: i.width() * o,
                    magnifiedHeight: i.height() * o,
                    afterLoad: function() {
                        $("body").width() < s && n.destroy()
                    }
                })
            }), $("#tab-container .etabs > li").length > 0 && $("#tab-container").easytabs();
            var r = this._initVariants();
            theme.sliders[this.slider].$sliderImage && (theme.sliders[this.slider].$sliderImage.on("beforeChange", this._matchVariantForCurrentSlide.bind(this)), t.data("show-featured-image") || this._switchImage(r)), this._stickyCartBtn(), this._removeReviewsDuplicate(), theme.initSwatches(), this._initAccordion(), this._initCountDownOffer(), this._productReviews(), this._responsiveElements(), this._productUpsells(), theme.dealOfTheDayInit("product");
            var a = "true" == new String("true"),
                c = $(".product-template").data("hide-variant-with-one-option"),
                l = $(".product-template").data("cell-size");
            theme.InitHideVariants(this.theProduct, a, c, l), setTimeout(function() {
                s._readMore()
            }, 3e3)
        }
    }(), theme.ProductPageSection.prototype = _.extend({}, theme.ProductPageSection.prototype, {
        onLoad: function() {
            _.isFunction(ajaxCart.qtySelectors) && ajaxCart.qtySelectors(), this._initAddToCartStickyBar()
        },
        onUnload: function() {
            delete theme.sliders[this.slider], delete theme.sliders[this.relSlider], $(document).off("touchmove.track-add-to-cart-btn"), $(document).off("scroll.track-add-to-cart-btn")
        },
        _stickyCartBtn: function() {
            if ($(this.selectors.stickyCartButton).length > 0) {
                if (!0 === $(".product-template").data("lock-atc-btn")) $(this.selectors.stickyCartButton).addClass("stuck");
                else $(document).on("scroll.track-add-to-cart-btn", this._trackScrolling.bind(this)), $(document).on("touchmove.track-add-to-cart-btn", this._trackScrolling.bind(this));
                $(this.selectors.stickyCartButton).on("click", this._submitCartForm.bind(this))
            }
        },
        _submitCartForm: function() {
            $(this.selectors.cartFormMobile).trigger("submit")
        },
        _trackScrolling: function() {
            if (theme.cache.$body.width() <= 767) {
                var e = $(this.selectors.stickyCartButton),
                    t = $(this.selectors.stickyBtnStart).position(),
                    i = window.pageYOffset + theme.cache.$window.height();
                t.top <= i ? e.addClass("stuck") : e.removeClass("stuck")
            }
        },
        _initVariants: function() {
            var e = {
                    $container: this.$container,
                    enableHistoryState: this.$container.data("enable-history-state") || !1,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.theProduct
                },
                t = new theme.Variants(e);
            return this.$container.on("variantChange", this._updateAddToCart.bind(this)), this.$container.on("variantImageChange", this._switchImage.bind(this)), this.$container.on("variantPriceChange", this._updatePrice.bind(this)), this.$container.on("variantSKUChange", this._updateSKU.bind(this)), t
        },
        _updateAddToCart: function(e) {
            var t, i = e.variant,
                s = this;

            function o(e, t) {
                $(s.selectors.addToCart).prop("disabled", e), $(s.selectors.addToCartText).text(t), $(s.selectors.stickyCartButton).find("button").prop("disabled", e), $(s.selectors.stickyCartButtonText).text(t), $(s.selectors.addToCartBarBtn).prop("disabled", e), $(s.selectors.addToCartBarBtnText).text(t)
            }
            i ? (this.$container.find(this.selectors.productPrices).removeClass("visibility-hidden"), $(this.selectors.addToCartBarPrice).removeClass("visibility-hidden").css("width", "auto"), i.available ? 0 == i.price && 1 == $(this.selectors.addToCartText).data("enabled-free-text") ? o(!1, $(this.selectors.addToCartText).data("original-text")) : o(!1, backend.strings.addToCart) : o(!0, backend.strings.soldOut), t = inventory_qty[i.id] > 0 ? inventory_qty[i.id] : i.available ? 1 : 0, this.$container.find(this.selectors.qty).html(t), $(this.selectors.originalSelectorId + "--desktop").val(i.id)) : (o(!0, backend.strings.unavailable), this.$container.find(this.selectors.productPrices).addClass("visibility-hidden"), $(this.selectors.addToCartBarPrice).addClass("visibility-hidden").css("width", 0), this.$container.find(this.selectors.qty).html("-"))
        },
        _switchImage: function(e) {
            var t;
            t = e.variant ? e.variant : e;
            var i, s = theme.sliders[this.slider];
            t.featured_image && ((i = this._getSlideIndexForVariant(s, t)) || 0 == i) && (this._transitionToVariant = t, s.$sliderImage.slick("slickGoTo", i))
        },
        _matchVariantForCurrentSlide: function(e, t, i, s) {
            var o = this._getVariantBySlideIndex(s);
            if (!o) return !1;
            var n = $(this.selectors.originalSelectorId),
                r = this;
            n.val() != o.id && _.each(o.options, function(e, t) {
                var i = t + 1,
                    s = "option-" + i,
                    o = r.$container.find(".swatches[data-index=" + i + "]");
                if (!(o.length > 0)) return $dropdown = r.$container.find(".single-option-selector[data-option=option" + i + "]"), $dropdown.val(e).trigger("change"), !0;
                o.find("input[name=" + s + "]").each(function(t, i) {
                    if ($(i).val() == e) return $(i).trigger("click"), !0
                })
            })
        },
        _getSlideIndexForVariant: function(e, t) {
            var i;
            return e.$sliderThumbs.find(".slick-slide:not(.slick-cloned)").each(function(e, s) {
                if (!i && $(s).find("img[data-id=" + t.featured_image.id + "]").length > 0) return i = e, !1
            }), i
        },
        _getVariantBySlideIndex: function(e) {
            var t, i, s, o = theme.sliders[this.slider].$sliderThumbs.find(".slick-slide:not(.slick-cloned)")[e];
            if (o) {
                if (t = $(o).find("img:first").data("id"), s = _.filter(this.theProduct.variants, function(e) {
                        return e.featured_image && e.featured_image.id == t
                    }), this._transitionToVariant && this._transitionToVariant.id) {
                    var n = this._transitionToVariant;
                    i = _.find(s, function(e) {
                        return e.id == n.id
                    })
                }
                i || (i = s[0])
            }
            return i
        },
        _updatePrice: function(e) {
            var t, i, s = e.variant,
                o = "";
            if (0 != $("body").data("discount-percent")) {
                var n = $("body").data("discount-percent"),
                    r = s.price * n / 100;
                o = theme.Currency.formatMoney(s.price - r, backend.moneyFormat)
            } else o = theme.Currency.formatMoney(s.price, backend.moneyFormat);
            if ("true" == new String("true") && (t = this.$container.find(".product-variant-prices-ref"), inCurrency = t.find("[data-variant-id=" + s.id + "]").html(), inCurrency && (inCurrencyParts = inCurrency.split("|"), o = inCurrencyParts[0], i = inCurrencyParts[1])), this.$container.find(this.selectors.originalPrice).html(o), s.compare_at_price > s.price) {
                n = Math.round(100 * (s.compare_at_price - s.price) / s.compare_at_price);
                i || (i = theme.Currency.formatMoney(s.compare_at_price, backend.moneyFormat)), this.$container.find(this.selectors.comparePrice).html(i), this.$container.find(this.selectors.discountPercent).html("-" + n + "%"), this.$container.find(this.selectors.salePriceWrapper).removeClass("hide")
            } else this.$container.find(this.selectors.salePriceWrapper).addClass("hide")
        },
        _updateSKU: function(e) {
            var t = e.variant;
            this.$container.find(this.selectors.SKU).html(t.sku)
        },
        _readMore: function() {
            this.$description = $(this.selectors.productDescription), this.descriptionHeight = Number($(this.selectors.productFullDescription).height());
            var e = this.$description.height(),
                t = this.descriptionHeight > 0,
                i = t && 100 - e / (this.descriptionHeight / 100) > "20";
            theme.isDesktop() ? (this.descriptionHeight = null, this._disableReadMore()) : t && i ? (this.$readMoreBtn = $(this.selectors.readMoreBtn), $(this.selectors.readMoreBtn).on("click", this._toggleReadMore.bind(this))) : this._disableReadMore()
        },
        _toggleReadMore: function() {
            this.$description.hasClass("product-info__description--shrunk") ? this._expandDescription() : this._collapseDescription()
        },
        _expandDescription: function() {
            this.$description.animate({
                height: this.descriptionHeight + "px"
            }, 300).removeClass("product-info__description--shrunk"), $(this.selectors.readMoreBtn).find(".icon").removeClass("icon-chevron-thin-down").addClass("icon-chevron-thin-up")
        },
        _collapseDescription: function() {
            theme.smoothScroll(this.$description, 300, -120), this.$description.animate({
                height: this.$description.data("original-height")
            }, 300).addClass("product-info__description--shrunk"), $(this.selectors.readMoreBtn).find(".icon").removeClass("icon-chevron-thin-up").addClass("icon-chevron-thin-down")
        },
        _disableReadMore: function() {
            this.descriptionHeight ? this.$description.css("height", this.descriptionHeight + 20 + "px") : this.$description.css("height", "100%"), this.$description.removeClass("product-info__description--shrunk"), $(this.selectors.readMoreBtn).remove()
        },
        _removeReviewsDuplicate: function() {
            theme.cache.$body.width() <= 767 ? $(".medium-down--hide .js-delete--mobile").remove() : $(".large--hide .js-delete--desktop").remove()
        },
        _initAccordion: function() {
            var e = $(this.selectors.accordion),
                t = e.find("dd").hide(),
                i = $(this.selectors.accordion + " > dt:first-child").next();
            1 != i.data("closed") && i.addClass("active").slideDown(), $(this.selectors.accordion + " > .accordion__tab-title").click(function() {
                return $this = $(this), $target = $this.next(), $target.hasClass("active") ? $target.removeClass("active").slideUp() : (theme.cache.$body.scrollTop() > e.offset().top && theme.smoothScroll(e, 1e3), t.removeClass("active").slideUp(), $target.addClass("active").slideDown()), !1
            })
        },
        _initAddToCartStickyBar: function() {
            if (0 != $("#product-add-to-cart-bar").length) {
                var e = $(window),
                    t = $(".product-form-wrapper .product-form__cart-submit.product-atc-btn"),
                    i = $(this.selectors.addToCart).offset().top,
                    s = $(this.selectors.addToCartBar),
                    o = $(this.selectors.addToCartBarBtn);
                e.scroll(function() {
                    e.scrollTop() > i ? (s.addClass("shown"), g()) : s.removeClass("shown")
                }), o.on("click", function(e) {
                    t[0].click(), $("html, body").animate({
                        scrollTop: 0
                    }, "fast"), e.preventDefault()
                });
                var n = s.find(".js-qty__adjust--minus"),
                    r = s.find(".js-qty__adjust--plus"),
                    a = s.find(".js-qty__num"),
                    c = $(this.selectors.productInfoDesktop).find(".product-quantity__content-desktop").find(".js-qty__adjust--minus"),
                    l = $(this.selectors.productInfoDesktop).find(".product-quantity__content-desktop").find(".js-qty__adjust--plus"),
                    d = $(this.selectors.productInfoDesktop).find(".product-quantity__content-desktop").find(".js-qty__num"),
                    h = $(this.selectors.productVariants).hasClass("product-options--swatches"),
                    u = $(this.selectors.productInfoDesktop).find(".product-price__price"),
                    p = s.find(".product-price");

                function m() {
                    null != $(this).closest(".product-add-to-cart-bar")[0] ? d.val(a.val()) : a.val(d.val()), g()
                }
                n.click(m), r.click(m), c.click(m), l.click(m);
                var f = this;

                function g() {
                    p.html(u.html())
                }
                s.find(".product-options__selector").each(function(e, t) {
                    var i, s, o = $(this);
                    i = $(f.selectors.productInfoDesktop).find(".single-option-selector").eq(e), s = o, i.on("change", function() {
                        "non" != i.val() && (s.val(i.val()), g())
                    }), s.on("change", function() {
                        "non" != s.val() && (i.val(s.val()).trigger("change"), g())
                    })
                }), h && s.find(".product-options__selector").each(function(e, t) {
                    var i = $(this),
                        s = $(this).attr("data-index").replace("option", "").trim();
                    i.change(function() {
                        $(".swatches__option.swatches__option-index-" + s + ".swatches__option--" + $(this).val().toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "")).click(), g()
                    })
                })
            }
        },
        _initCountDownOffer: function() {
            var e = "false",
                t = {
                    coc: $(".countdown-offer-clock"),
                    show: function() {
                        this.coc.removeClass("hide")
                    },
                    hide: function() {
                        this.coc.addClass("hide")
                    }
                },
                i = new theme.CookieManager;

            function s(s, o, n) {
                var r, a = "konversion-countdown-" + o,
                    c = null;
                if (i.check(a)) {
                    var l = i.get(a).split("-"),
                        d = l[0];
                    l[1] == parseInt(s[0], 10) + parseInt(s[1], 10) + parseInt(s[2], 10) ? c = new Date(parseInt(d)) : h()
                } else h();

                function h() {
                    var e = new Date;
                    c = e.addDays(parseInt(s[0], 10)).addHours(parseInt(s[1], 10)).addMinutes(parseInt(s[2], 10)), i.set(a, c.getTime() + "-" + parseInt(s[0], 10) + parseInt(s[1], 10) + parseInt(s[2], 10), 30)
                }

                function u() {
                    setTimeout(function() {
                        t.show()
                    }, 1e3);
                    var i = new Date,
                        s = c.getTime() - i.getTime();
                    r = setInterval(function() {
                        var i = s;
                        if (i < 0) clearInterval(r), t.hide(), "true" == e && (h(), u());
                        else {
                            var o = Math.floor(i / 1e3),
                                a = Math.floor(o / 60),
                                c = Math.floor(a / 60),
                                l = Math.floor(c / 24);
                            c %= 24, a %= 60, o %= 60, l %= 24, n.text(l + "d " + c + "h " + a + "m " + o + "s ")
                        }
                        s -= 1e3
                    }, 1e3)
                }
                u()
            }
            var o = "true" == new String("false"),
                n = window.location.href + ".json";
            $.ajax({
                url: n,
                dataType: "JSON",
                async: !0,
                success: function(e) {
                    if (o) {
                        var t = $(r.selectors.countDownOffer),
                            n = e.product.id,
                            a = e.product.tags.split(", "),
                            c = (d = a, h = "countdown-", u = null, $.each(d, function(e, t) {
                                t.includes(h) && (u = t)
                            }), u || !1);
                        if (c) {
                            t.css("display", "block").css("text-transform", "lowercase").css("font-size", "13px"), 1 == t.parents(".product-form__cart--sticky").length && t.parents(".product-form__cart--sticky").addClass("w-countdown").find(r.selectors.countDownOffer);
                            var l = c.split("-");
                            l.shift(), s(l, n, $(".countdown-offer-clock .countdown-clock"))
                        } else t.parents(".product-form__cart--sticky").removeClass("w-countdown"), i.remove("konversion-countdown-" + n)
                    }
                    var d, h, u
                },
                error: function() {
                    console.error("Countdown offer: Oops, something went wrong Unable to load product data")
                }
            });
            var r = this
        },
        _productReviews: function() {
            $(".open-reviews-tab").on("click", function(e) {
                e.preventDefault(), $(window).width() > 420 ? ($("html, body").animate({
                    scrollTop: $(".reviews-tab").offset().top - 170
                }, 700), $(".reviews-tab").click()) : ($("dl").find(".active").removeClass("active").css("display", "none"), $("html, body").animate({
                    scrollTop: $("dt.reviews-tab").offset().top - 170
                }, 700), $(".product-info-bottom dt.reviews-tab").next().hasClass("active") || $(".product-info-bottom dt.reviews-tab").click())
            })
        },
        _responsiveElements: function() {
            var e, t = $(window),
                i = $(".product-form-position-normal"),
                s = $(".product-form-position-bottom");
            t.on("resize", function() {
                t.width() >= theme.mobileBreakpoint && "desktop" !== e ? (e = "desktop", $(".product-template .product-info").removeClass("page-width product-info-mobile").addClass("product-info-desktop"), $(".product-form-wrapper .product-form").removeClass("product-form--mobile").addClass("product-form--desktop"), "" != s.html() && (i.get(0).innerHTML = s.html(), s.html("")), $(".product-quantity__content-desktop").each(function() {
                    "grid" == $(this).data("content") ? $(this).html($(".product-quantity__grid").html()) : $(this).html($(".product-quantity__snippet").html())
                }), $(".product-quantity__content-mobile").each(function() {
                    $(this).empty()
                }), $(".product-dropdown__quantity").length > 0 && $(".product-dropdown__quantity").empty()) : t.width() < theme.mobileBreakpoint && "mobile" !== e && (e = "mobile", $(".product-template .product-info").removeClass("product-info-desktop").addClass("page-width product-info-mobile"), $(".product-form-wrapper .product-form").removeClass("product-form--desktop").addClass("product-form--mobile"), "bottom" == $("#product-form-mobile-position").val() ? "" != i.html() && (s.get(0).innerHTML = i.html(), i.html(""), theme.initSwatches()) : "" != $(".product-form-position-bottom").html() && (i.get(0).innerHTML = s.html(), s.html("")), $(".product-form").hasClass("product-form--swatch") ? $(".product-quantity__content-mobile").each(function() {
                    "grid" == $(this).data("content") ? $(this).html($(".product-quantity__grid").html()) : $(this).html($(".product-quantity__snippet").html())
                }) : ($(".product-dropdown__quantity").length <= 0 && $(".product-form__variants.hider").after('<div class="product-dropdown__quantity"></div>'), $(".product-dropdown__quantity").html($(".product-quantity__grid").html())), $(".product-quantity__content-desktop").each(function() {
                    $(this).empty()
                }))
            }).resize()
        },
        _productUpsells: function() {
            $(".product-upsell-wrapper .product-upsells__col").on("click", function(e) {
                e.preventDefault(), $(this).toggleClass("active")
            })
        }
    }), theme.RelatedProductsSliderCart = function() {
        this.$relSlider = null;
        return function(e) {
            this.$relSlider = $(e), this.settings = {
                dots: !1,
                fade: !1,
                speed: 500,
                infinite: !0,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }]
            }, this.$relSlider.slick(this.settings)
        }
    }(), theme.CartPageSection = function() {
        return function(e) {
            var t = this.$container = $(e);
            this.settings = {
                mobileSize: 1024
            };
            var i = this.relSlider = "#slider_related-products";
            theme.sliders[i] = new theme.RelatedProductsSliderCart(i), theme.productCardsInit(t), t.find(".cart__continue-btn").on("click", function() {
                window.location = document.referrer
            })
        }
    }(), theme.CartPageSection.prototype = _.extend({}, theme.CartPageSection.prototype, {
        onUnload: function() {
            delete theme.sliders[this.relSlider]
        }
    }), theme.CollectionTemplate = function() {
        return function(e) {
            var t = $(e);
            theme.productCardsInit(t), t.find(".collection-filter__items--tags input").change(this.filterUpdate.bind(this)), $(window).scroll(function() {
                $(window).width() < 1024 ? theme.ScrollExecute({
                    container: t
                }) : theme.ScrollExecute({
                    container: t,
                    more_class: ".more-desktop",
                    product_wrapper: ".product-desktop",
                    end_point: "#product-list-foot-desktop",
                    device: "desktop"
                })
            }), this.tagFilterCollapse()
        }
    }(), theme.CollectionTemplate.prototype = _.extend({}, theme.CollectionTemplate.prototype, {
        filterUpdate: function(e) {
            var t = $(e.target).parent().find("a");
            window.location = t.prop("href")
        },
        tagFilterCollapse: function() {
            var e = $(".collapsible-title"),
                t = $(".collection-filter");
            e.on("click", function(e) {
                $thisCollapsibleTitle = $(this);
                var t = $thisCollapsibleTitle.attr("toggle"),
                    i = $("." + t);
                $thisCollapsibleTitle.hasClass("closed") ? ($thisCollapsibleTitle.removeClass("closed"), i.removeClass("closed")) : ($thisCollapsibleTitle.addClass("closed"), i.addClass("closed"))
            }), e.each(function() {
                $thisCollapsibleTitle = $(this);
                var e = "." + $thisCollapsibleTitle.attr("toggle"),
                    t = $thisCollapsibleTitle.attr("max-items"),
                    i = $(e + "> li"),
                    s = [];
                i.each(function(e, t) {
                    s[e] = $(this).find("input[type=checkbox]").attr("checked")
                }), isNaN(t) || 0 == t || i.length >= t && -1 == $.inArray("checked", s) && ($thisCollapsibleTitle.addClass("closed"), $(e).addClass("closed"))
            }), t.css("visibility", "visible")
        }
    }), theme.ScrollExecute = function() {
        return function(e) {
            e = $.extend({}, {
                more_class: ".more-mobile",
                product_wrapper: ".product-mobile",
                end_point: "#product-list-foot-mobile",
                device: "mobile",
                scroll_height: 800,
                loading_bar: '<img src="//www.bandanaswholesale.com/cdn/shop/t/14/assets/ajax-loader.gif?v=41356863302472015721676959378" />',
                delay: 200
            }, e), setTimeout(function() {
                if ($(document).height() - e.scroll_height < $(document).scrollTop() + $(window).height()) {
                    var t;
                    scrollNode = $(e.more_class).last(), scrollURL = $(e.more_class).find("a").last().attr("href");
                    var i = function(i) {
                        !i && scrollNode.length > 0 && "none" != scrollNode.css("display") && $.ajax({
                            type: "GET",
                            url: scrollURL,
                            beforeSend: function() {
                                "mobile" == e.device ? $.pInfScrLoading_mobile = !0 : $.pInfScrLoading_desktop = !0, (t = scrollNode.clone().empty().append(e.loading_bar)).insertAfter(scrollNode), scrollNode.hide()
                            },
                            success: function(i) {
                                scrollNode.next().remove(), $(i).find(e.product_wrapper).insertBefore($(e.end_point)), t.remove();
                                var s = [].slice.call(document.querySelectorAll("img.lazy"));
                                let o = new IntersectionObserver(function(e, t) {
                                    e.forEach(function(e) {
                                        if (e.isIntersecting) {
                                            let t = e.target;
                                            t.src = t.dataset.src, t.srcset = t.dataset.srcset, t.classList.remove("lazy"), o.unobserve(t)
                                        }
                                    })
                                });
                                s.forEach(function(e) {
                                    o.observe(e)
                                }), "mobile" == e.device ? $.pInfScrLoading_mobile = !1 : $.pInfScrLoading_desktop = !1, theme.productCardsInit(e.container)
                            },
                            dataType: "html"
                        })
                    };
                    "mobile" == e.device ? i($.pInfScrLoading_mobile) : i($.pInfScrLoading_desktop)
                }
            }, e.delay)
        }
    }(), theme.ContactTemplate = function() {
        return function(e) {
            var t = $(e);
            theme.productCardsInit(t), theme.setupMap(t)
        }
    }(), theme.PageTemplate = function() {
        return function(e) {
            var t = $(e);
            theme.productCardsInit(t)
        }
    }(), theme.FeaturedCollectionSection = function() {
        return function(e) {
            var t = $(e);
            theme.productCardsInit(t)
        }
    }(), theme.FeaturedProductSection = function() {
        return function(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id");
            this.theProduct = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML), this.settings = {
                sectionId: i,
                enableHistoryState: t.data("enable-history-state") || !1
            }, this.selectors = {
                originalSelectorId: "#ProductSelect-" + i,
                singleOptionSelector: ".single-option-selector",
                addToCart: "#" + i + " .product-form__cart-submit",
                addToCartText: "#" + i + " .product-form__cart-submit-text",
                productPrices: ".product-info .product-price",
                originalPrice: ".product-info .product-price__price",
                comparePrice: ".product-info .product-price__old",
                discountPercent: ".product-info .product-price__percent",
                salePriceWrapper: ".product-info .product-price__sale"
            };
            var s = this.slider = "#" + i + "_images";
            theme.sliders[s] = new theme.ProductImagesSlider(s);
            var o = this.relSlider = "#slider_related-products";
            theme.sliders[o] = new theme.RelatedProductsSlider(o), theme.productCardsInit(t), t.find(".product-images--single .product-images__image, .product-images__image li").each(function(e, t) {
                var i = $(t).find(".zoom"),
                    s = i.data("zoom-status"),
                    o = i.data("zoom-setting");
                if (0 != s) var n = i.magnify({
                    magnifiedWidth: i.width() * o,
                    magnifiedHeight: i.height() * o,
                    afterLoad: function() {
                        $("body").width() < s && n.destroy()
                    }
                })
            }), this._initVariants(), theme.initSwatches(), this._responsiveElements(this.settings);
            var n = "true" == new String("true"),
                r = $('div[data-section-type="featured-product-section"]').data("hide-variant-with-one-option");
            theme.InitHideVariants(this.theProduct, n, r, "")
        }
    }(), theme.FeaturedProductSection.prototype = _.extend({}, theme.FeaturedProductSection.prototype, {
        onLoad: function() {
            _.isFunction(ajaxCart.qtySelectors) && ajaxCart.qtySelectors()
        },
        onUnload: function() {
            delete theme.sliders[this.slider], delete theme.sliders[this.relSlider]
        },
        _initVariants: function() {
            var e = {
                $container: this.$container,
                enableHistoryState: this.$container.data("enable-history-state") || !1,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.theProduct
            };
            this.variants = new theme.Variants(e), this.$container.on("variantChange", this._updateAddToCart.bind(this)), this.$container.on("variantImageChange", this._switchImage.bind(this)), this.$container.on("variantPriceChange", this._updatePrice.bind(this))
        },
        _updateAddToCart: function(e) {
            var t = e.variant;
            t ? (this.$container.find(this.selectors.productPrices).removeClass("visibility-hidden"), t.available ? ($(this.selectors.addToCart).prop("disabled", !1), $(this.selectors.addToCartText).text($(this.selectors.addToCartText).data("original-text"))) : ($(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCartText).text(backend.strings.soldOut)), $(this.selectors.originalSelectorId + "--desktop").val(t.id)) : ($(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCartText).text(backend.strings.unavailable), this.$container.find(this.selectors.productPrices).addClass("visibility-hidden"))
        },
        _switchImage: function(e) {
            var t = e.variant;
            theme.sliders[this.slider].$sliderImage.slick("slickGoTo", t.featured_image.position - 1)
        },
        _updatePrice: function(e) {
            var t, i, s = e.variant,
                o = theme.Currency.formatMoney(s.price, backend.moneyFormat);
            if ("true" == new String("true") && (t = this.$container.find(".product-variant-prices-ref"), inCurrency = t.find("[data-variant-id=" + s.id + "]").html(), inCurrencyParts = inCurrency.split("|"), o = inCurrencyParts[0], i = inCurrencyParts[1]), this.$container.find(this.selectors.originalPrice).html(o), s.compare_at_price > s.price) {
                var n = Math.round(100 * (s.compare_at_price - s.price) / s.compare_at_price);
                i || (i = theme.Currency.formatMoney(s.compare_at_price, backend.moneyFormat)), this.$container.find(this.selectors.comparePrice).html(i), this.$container.find(this.selectors.discountPercent).html("-" + n + "%"), this.$container.find(this.selectors.salePriceWrapper).removeClass("hide")
            } else this.$container.find(this.selectors.salePriceWrapper).addClass("hide")
        },
        _responsiveElements: function(e) {
            var t, i = $(window);
            i.on("resize", function() {
                i.width() >= theme.mobileBreakpoint && "desktop" !== t ? (t = "desktop", $("#" + e.sectionId + " .product-info").removeClass("page-width product-info-mobile").addClass("product-info-desktop"), $("#" + e.sectionId + " .product-form").removeClass("product-form--mobile").addClass("product-form--desktop"), $(".product-quantity__content-desktop").each(function() {
                    "grid" == $(this).data("content") ? $(this).html($(".product-quantity__grid").html()) : $(this).html($(".product-quantity__snippet").html())
                }), $(".product-quantity__content-mobile").each(function() {
                    $(this).empty()
                }), $(".product-dropdown__quantity").length > 0 && $(".product-dropdown__quantity").empty()) : i.width() < theme.mobileBreakpoint && "mobile" !== t && (t = "mobile", $("#" + e.sectionId + " .product-info").removeClass("product-info-desktop").addClass("page-width product-info-mobile"), $("#" + e.sectionId + " .product-form").removeClass("product-form--desktop").addClass("product-form--mobile"), $("#" + e.sectionId + " .product-form").hasClass("product-form--swatch") ? $("#" + e.sectionId + " .product-quantity__content-mobile").each(function() {
                    "grid" == $(this).data("content") ? $(this).html($(".product-quantity__grid").html()) : $(this).html($(".product-quantity__snippet").html())
                }) : ($("#" + e.sectionId + " .product-dropdown__quantity").length <= 0 && $("#" + e.sectionId + " .product-form__variants.hider").after('<div class="product-dropdown__quantity"></div>'), $("#" + e.sectionId + " .product-dropdown__quantity").html($("#" + e.sectionId + " .product-quantity__grid").html())), $("#" + e.sectionId + " .product-quantity__content-desktop").each(function() {
                    $(this).empty()
                }))
            }).resize()
        }
    }), theme.DealOfTheDay = function() {
        return function(e) {
            if (this.$selectors = {
                    dealOfTheDay: $(".content-deal-of-the-day"),
                    dealOfTheDayProduct: $(".deal-of-the-day-product")
                }, void 0 === t) var t = {
                shopUrl: "",
                currencyName: "USD"
            };
            this.currentDateHours = '2024-09-12-20-25-37';
            var i = this.currentDateHours.split("-");
            this.currentDate = i[0] + "-" + i[1] + "-" + i[2], this.storeCurrencySymbol = theme.currencySymbols[t.currencyName], "widget" == e && this.widget(), "product" == e && this.product()
        }
    }(), theme.DealOfTheDay.prototype = _.extend({}, theme.DealOfTheDay.prototype, {
        widget: function() {
            var e = this,
                t = "konversion_dotd_widget";

            function i(i) {
                ! function(e, t) {
                    $.get(backend.shopUrl + "/collections/deal-of-the-day/products.json?limit=250", {}, function(i) {
                        var s = !0;
                        $.each(i.products, function(i, o) {
                            if (-1 != o.tags.indexOf(e)) return s = !1, t(o), !1
                        }), s && t(!1)
                    })
                }("deal-" + e.currentDate, function(e) {
                    console.log(e), e ? (localStorage.setItem(t, JSON.stringify({
                        product: e
                    })), i()) : localStorage.removeItem(t)
                })
            }

            function s(t) {
                if (t <= 0) clearInterval(timer), $(".cart-cell").removeClass("deal-of-the-day-active"), e.$selectors.dealOfTheDay.fadeOut();
                else {
                    var i = Math.floor(t / 1e3),
                        s = Math.floor(i / 60),
                        o = Math.floor(s / 60);
                    s %= 60, i %= 60;
                    var n = new Date(0, 0, 0, o %= 24, s, i).toTimeString().split(" ")[0];
                    e.$selectors.dealOfTheDay.find(".dealzoneCounter").text(n)
                }
            }

            function o() {
                n = JSON.parse(localStorage.getItem(t)), e.$selectors.dealOfTheDay.fadeIn(), $(".cart-cell").addClass("deal-of-the-day-active");
                var i = n.product.variants[0].compare_at_price,
                    o = n.product.variants[0].price;
                if (null == i) e.$selectors.dealOfTheDay.find(".discount-percentage").css("display", "none"), e.$selectors.dealOfTheDay.find(".compared_at").css("display", "none");
                else {
                    var r = 100 * (o - i) / i;
                    r = Math.round(10 * r) / 10, e.$selectors.dealOfTheDay.find(".discount-percentage").html(r + "%"), e.$selectors.dealOfTheDay.find(".compared_at").html(e.storeCurrencySymbol + i)
                }
                e.$selectors.dealOfTheDay.find(".price").html(e.storeCurrencySymbol + o);
                var a = n.product.images[0].src.replace(".jpg", "_compact.jpg");
                e.$selectors.dealOfTheDay.find(".product-image").attr("src", a), e.$selectors.dealOfTheDay.find(".product-link").attr("href", window.location.origin + "/products/" + n.product.handle);
                var c, l, d, h, u, p = n.product.tags[n.product.tags.indexOf("deal-" + e.currentDate)].replace("deal-", "");
                c = e.currentDateHours, l = p, d = c.split("-"), h = l.split("-"), l = new Date(h[0], h[1], h[2], 23, 59, 59), c = new Date(d[0], d[1], d[2], d[3], d[4], d[5]), u = l.getTime() - c.getTime(), setInterval(function() {
                    s(u), u -= 1e3
                }, 1e3)
            }
            var n = JSON.parse(localStorage.getItem(t));

            function r() {
                i(function() {
                    o()
                })
            }
            null == n ? r() : (-1 == n.product.tags.indexOf("deal-" + this.currentDate) ? r() : o(), $(".product-template").length && n.product.id == $(".product-template")[0].id.replace("product_", "") && (console.log("works"), r())), this.$selectors.dealOfTheDay.find(".product-link").click(function() {
                localStorage.removeItem(t)
            })
        },
        product: function() {
            var e, t, i, s, o, n, r = this,
                a = "deal-" + r.currentDate;

            function c(e) {
                if (e <= 0) clearInterval(timer), r.$selectors.dealOfTheDayProduct.fadeOut();
                else {
                    var t = Math.floor(e / 1e3),
                        i = Math.floor(t / 60),
                        s = Math.floor(i / 60);
                    i %= 60, t %= 60;
                    var o = new Date(0, 0, 0, s %= 24, i, t).toTimeString().split(" ")[0];
                    r.$selectors.dealOfTheDayProduct.find(".countdown").text(o)
                }
            } - 1 != $(".product-template").data("all-tags").split(";").indexOf(a) && (r.$selectors.dealOfTheDayProduct.fadeIn(), e = r.currentDateHours, t = a.replace("deal-", ""), i = e.split("-"), s = t.split("-"), t = new Date(s[0], s[1], s[2], 23, 59, 59), e = new Date(i[0], i[1], i[2], i[3], i[4], i[5]), o = t.getTime() - e.getTime(), n = 100 - o / 864e5 * 100, r.$selectors.dealOfTheDayProduct.find(".progress-bar > .bar").animate({
                width: n + "%"
            }), setInterval(function() {
                c(o), o -= 1e3
            }, 1e3))
        }
    }), theme.dealOfTheDayInit = function(e) {
        this.isEnabled = "true" == new String("false"), this.isEnabled && new theme.DealOfTheDay(e)
    }, theme.topBar = function() {
        if (!theme.adminSet) {
            var e = $(".fake-share-button"),
                t = $(".fake-like-button");
            e.css("display", "none"), t.css("display", "none")
        }
    }, theme.footer = function() {
        $(".menu-collapse-btn").click(function() {
            var e = $(this).data("collapsible-id"),
                t = $(".collapsible-id-" + e);
            t.hasClass("collapsed") ? ($(this).removeClass("collapsed"), t.removeClass("collapsed")) : ($(this).addClass("collapsed"), t.addClass("collapsed"))
        })
    }, theme.adminSet = !1, theme.setupAdmin = function() {
        if (!theme.adminSet) {
            console.log("Setting admin"), theme.adminSet = !0;
            var e = document.createElement("style");
            e.appendChild(document.createTextNode("@font-face { font-family: 'font-admin'; src: url('https://get.tabarnapp.com/cdn/admin-font.ttf?cache_bust=50d16c0036b9717744a17b149820680c75598a75') format('truetype'); }")), document.head.appendChild(e), $('<span id="is_admin">&nbsp;</span>').appendTo("body").css({
                fontFamily: "font-admin"
            })
        }
    }, window.top.location !== window.location && theme.setupAdmin(), theme.check_interval = !1, theme.success_license = function() {
        swal({
            title: "License activated",
            html: "Your license key has been successfully activated",
            type: "success"
        })
    }, theme.wrn = function() {
        swal({
            title: "License not activated",
            html: "Sorry, we could not verify your license. Go to <strong>Customize theme</strong> &gt; <strong>General Settings</strong> &gt; <strong>License</strong> and paste your license key from the license.txt file.  If you don’t have a license, puchase one at <a href='https://www.konversiontheme.com' target='_blank'>www.konversiontheme.com</a>. <br> <span id='swal_mes'></span>",
            type: "error",
            confirmButtonText: "Continue anyway",
            showLoaderOnConfirm: !0,
            confirmButtonColor: "#AAAAAA",
            showLoaderOnConfirm: !0,
            allowOutsideClick: !1,
            allowEscapeKey: !1,
            allowEnterKey: !1,
            showCancelButton: !0,
            cancelButtonText: "Activate my license",
            cancelButtonColor: "#41cd62",
            preConfirm: function() {
                return swal.disableButtons(), new Promise(function(e) {
                    !1 !== theme.check_interval && clearInterval(theme.check_interval);
                    var t = 15;
                    $("#swal_mes").text("Window will be ready in " + t + " seconds."), theme.check_interval = setInterval(function() {
                        if (t <= 0) return clearInterval(theme.check_interval), void e();
                        t -= 1, $("#swal_mes").text("Window will be ready in " + t + " seconds.")
                    }, 1e3)
                })
            }
        }).then(null, function(e) {
            "cancel" === e && (window.open("https://desk.zoho.com/portal/tabarnapp/kb/articles/how-to-activate-your-license", "_blank"), theme.wrn())
        })
    }, theme.check_license = function() {
        var e = "50d16c0036b9717744a17b149820680c75598a75",
            t = localStorage.getItem("tabarnapp_last_license");
        parseInt(localStorage.getItem(e) || -1) <= 0 ? (localStorage.setItem("tabarnapp_last_license", e), theme.wrn()) : e !== t && (localStorage.setItem("tabarnapp_last_license", e), theme.success_license())
    }, theme.setup_license = function() {
        var e = "3db3aa75cdabc6965f686ad2dd195a8038ee4c23ac496332ba7fcff02e0595f4",
            t = "50d16c0036b9717744a17b149820680c75598a75";
        $.getJSON("https://get.tabarnapp.com/cdn/cl.php?l=" + e, function(e) {
            e && 0 !== e.status ? localStorage.setItem(t, e.status) : localStorage.setItem(t, 0), theme.check_license()
        })
    }, window.top.location !== window.location && theme.setup_license(), theme.init = function() {
        FastClick.attach(document.body), theme.cacheSelectors(), theme.drawersInit(), theme.modalInit(), theme.mobileNavInit(), theme.instaFeedInit(), theme.loginForms(), theme.dealOfTheDayInit("widget"), theme.topBar(), theme.footer(), theme.SplashModalEl && theme.splashModals()
    },
    function() {
        var e = $("#BlogTagFilter");
        e.length && e.on("change", function() {
            location.href = $(this).val()
        })
    }(), $(theme.init), $(document).ready(function() {
        var e = new theme.Sections;
        e.register("header-section", theme.HeaderSection), e.register("slideshow-section", theme.SlideshowSection), e.register("slider-section", theme.SliderSection), e.register("product-template", theme.ProductPageSection), e.register("cart-template", theme.CartPageSection), e.register("collection-template", theme.CollectionTemplate), e.register("contact-template", theme.ContactTemplate), e.register("page-template", theme.PageTemplate), e.register("featured-collection-section", theme.FeaturedCollectionSection), e.register("featured-product-section", theme.FeaturedProductSection), e.register("password-header", theme.PasswordHeader), $('[data-tooltip!=""]').qtip({
            content: {
                attr: "data-tooltip"
            },
            style: {
                classes: "qtip-light qtip-shadow"
            }
        })
    }), document.addEventListener("DOMContentLoaded", function() {
        if ("IntersectionObserver" in window) {
            var e = [].slice.call(document.querySelectorAll("img.lazy"));
            let i = new IntersectionObserver(function(e, t) {
                e.forEach(function(e) {
                    if (e.isIntersecting) {
                        let t = e.target;
                        t.src = t.dataset.src, t.srcset = t.dataset.srcset, t.classList.remove("lazy"), i.unobserve(t)
                    }
                })
            });
            e.forEach(function(e) {
                i.observe(e)
            });
            var t = [].slice.call(document.querySelectorAll("div.slideshow__image.lazy"));
            let s = new IntersectionObserver(function(e, t) {
                e.forEach(function(e) {
                    if (e.isIntersecting) {
                        let t = e.target;
                        t.style.backgroundImage = "url('" + t.dataset.image + "')", t.classList.remove("lazy"), s.unobserve(t)
                    }
                })
            });
            t.forEach(function(e) {
                s.observe(e)
            })
        }
    }), theme.PasswordHeader = function() {
        function e() {
            this.init()
        }
        return e.prototype = _.extend({}, e.prototype, {
            init: function() {
                $(".js-toggle-login-modal").magnificPopup({
                    type: "inline",
                    mainClass: "mfp-fade",
                    closeOnBgClick: !1,
                    closeBtnInside: !1,
                    closeOnContentClick: !1,
                    tClose: "Close",
                    removalDelay: 500,
                    callbacks: {
                        open: function() {
                            window.setTimeout(function() {
                                document.getElementById("password").focus()
                            }, 50)
                        },
                        close: function() {
                            window.setTimeout(function() {
                                document.getElementById("email").focus()
                            }, 50)
                        }
                    }
                }), $(".storefront-password-form .errors").size() && $(".js-toggle-login-modal").click()
            }
        }), e
    }(), theme.HideVariants = function() {
        return function(e, t, i, s) {
            if (jQuery(function(t) {
                    t(window).on("resize", function() {
                        var i = 0;
                        for (option in e.options) t(window).width() < 1024 ? t(".selector-wrapper:eq(" + i + ")").parent().hasClass("grid__item") || t(".selector-wrapper:eq(" + i + ")").wrap('<div class="grid__item grid__item--full ' + s + '"></div>') : t(".selector-wrapper:eq(" + i + ")").parent().hasClass("grid__item") && t(".selector-wrapper:eq(" + i + ")").unwrap(), i++
                    }).resize()
                }), e.available && e.variants.length > 0) {
                var o = $("body").data("remove-query-parameter");
                if (new Shopify.OptionSelectors("ProductSelect-product_" + e.id + "--desktop", {
                        product: e,
                        onVariantSelected: function(t, s) {
                            if (t && $("#ProductSelect-product_" + e.id + "--desktop").val(t.id).trigger("change"), i) {
                                var o = $("form.product-form .selector-wrapper");
                                1 == e.variants.length && o.hide()
                            }
                        },
                        enableHistoryState: !o
                    }), t) {
                    if (e.available && e.options.length > 0 && Shopify.linkOptionSelectors(e), 1 == e.options.length)
                        for (variant in $(".selector-wrapper:eq(0)").prepend("<label>" + e.options[0] + "</label>"), e.variants) variant.available && jQuery(".single-option-selector option").filter(function() {
                            return jQuery(this).html() === variant.title
                        }).remove()
                } else 1 == e.options.length && $(".selector-wrapper:eq(0)").prepend("<label>" + e.options[0] + "</label>")
            }
        }
    }(), theme.HideVariants.prototype = _.extend({}, theme.HideVariants.prototype, {}), theme.InitHideVariants = function(e, t, i, s) {
        new theme.HideVariants(e, t, i, s)
    };